import type {Outcome, OutcomeColor} from 'iq-interview_experiences/types';

export const OUTCOME_OPTIONS: {value: Outcome; label: string}[] = [
  {value: 'got-offer', label: 'Got offer'},
  {value: 'rejected', label: 'Rejected'},
  {value: 'withdrew', label: 'Withdrew'},
  {value: 'waiting-reply', label: 'Waiting for reply'},
];

export const OUTCOME_COLOR_OPTIONS: Record<Outcome, OutcomeColor> = {
  'got-offer': 'green',
  rejected: 'red',
  withdrew: 'yellow',
  'waiting-reply': 'yellow',
};

export const OUTCOME_SELECTED_CLASSES: Record<Outcome, string> = {
  'got-offer': 'bg-iq-green text-white border-iq-green',
  rejected: 'bg-iq-red text-white border-iq-red',
  withdrew: 'bg-iq-yellow text-iq-black border-iq-yellow',
  'waiting-reply': 'bg-iq-yellow text-iq-black border-iq-yellow',
};

export const RELATIVE_DATE_OPTIONS = [
  {value: 'this_week', label: 'This week'},
  {value: 'last_month', label: 'Last month'},
  {value: '2_3_months', label: '2–3 months ago'},
  {value: '6_months', label: '6 months ago'},
];

export function resolveRelativeDate(value: string): string {
  const now = new Date();
  const monthsAgo = value === 'last_month' ? 1 : value === '2_3_months' ? 2 : value === '6_months' ? 6 : 0;
  if (monthsAgo > 0) {
    // Clamp to the 1st before month arithmetic: stepping back from e.g. the
    // 31st overflows short months and rolls into the wrong month.
    now.setDate(1);
    now.setMonth(now.getMonth() - monthsAgo);
  }
  return now.toISOString().split('T')[0]!;
}
